import articlesJson from '../../../../data/guides/articles.json';

export interface GuideSection {
  heading: string;
  content: string;
}

export interface GuideFaq {
  question: string;
  answer: string;
}

export interface GuideArticle {
  slug: string;
  title: string;
  metaDescription: string;
  quickAnswer: string;
  intro: string;
  publishedAt: string;
  /** Optional last-updated date (ISO YYYY-MM-DD). Falls back to publishedAt. */
  updatedAt?: string;
  categorySlug: string;
  localSeoSlug: string;
  sections: GuideSection[];
  faqs: GuideFaq[];
  relatedGuides: string[];
}

export const GUIDE_ARTICLES: GuideArticle[] = articlesJson as GuideArticle[];

export function getGuideBySlug(slug: string): GuideArticle | undefined {
  return GUIDE_ARTICLES.find((a) => a.slug === slug);
}

export function getGuideSeo(slug: string): { title: string; description: string } | null {
  const article = getGuideBySlug(slug);
  if (!article) return null;
  return {
    title: `${article.title} | Virtoly Guides`,
    description: article.metaDescription,
  };
}
